import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertAtomospheric = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.8 15.05C43.625 7.95 37.425 2.5 30 2.5C24.55 2.5 19.575 5.45 16.95 10.15C10.225 11.025 5 16.85 5 23.75C5 31.325 11.175 37.5 18.75 37.5H43.75C49.95 37.5 55 32.45 55 26.25C55 20.4 50.525 15.575 44.8 15.05ZM43.75 32.5H18.75C13.925 32.5 10 28.575 10 23.75C10 19.4 13.275 15.675 17.6 15.1L20.075 14.775L21.3 12.6C23.075 9.45 26.4 7.5 30 7.5C34.85 7.5 39.075 11.1 39.875 15.875L40.5 19.675L44.35 20.025C47.525 20.325 50 23.05 50 26.25C50 29.7 47.2 32.5 43.75 32.5Z",
			fill: "#FBC02D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37 40L29.75 48.3L34.75 50.8L28.875 57.5H35.5L42.75 49.2L37.75 46.7L43.625 40H37Z",
			fill: "#FBC02D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 40L14.75 48.3L19.75 50.8L13.875 57.5H20.5L27.75 49.2L22.75 46.7L28.625 40H22Z",
			fill: "#FBC02D"
		})
	]
});
export default SvgAlertAtomospheric;
